import { render, staticRenderFns } from "./personExperienceComponent.vue?vue&type=template&id=95d7ca1a&scoped=true&"
import script from "./personExperienceComponent.vue?vue&type=script&lang=js&"
export * from "./personExperienceComponent.vue?vue&type=script&lang=js&"
import style0 from "./personExperienceComponent.vue?vue&type=style&index=0&id=95d7ca1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d7ca1a",
  null
  
)

export default component.exports